import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CountryService } from 'src/app/services/country.service';
import { concatMap } from 'rxjs/operators';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyService } from 'src/app/services/company.service';
import { CountryResponseV2 } from 'src/app/models/country.model';
import { CompanyActivityNameResponse, CompanyContactRequest, CompanyPhoneRequest, CompanyRequest, CompanyScheduleRequest } from 'src/app/models/company.model';
import { HttpErrorResponse } from '@angular/common/http';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { UserSaved } from 'src/app/models/user.model';
declare let $: any;

@Component({
  selector: 'app-modal-company',
  templateUrl: './modal-company.component.html',
  styleUrls: ['./modal-company.component.scss']
})
export class ModalCompanyComponent implements OnInit {
  user: UserSaved;
  newCompany: CompanyRequest = new CompanyRequest();
  schedules: CompanyScheduleRequest[] = [];
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();

  constructor(
    private countryService: CountryService,
    private toastService: ToastrService,
    private companyService: CompanyService,
    private rolesAndPermissionsService: RolesAndPermissionsService,
    private authService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
      
  }

  getDisabledGeneral() {
    if (!this.newCompany.name
      || !this.newCompany.nit
      || !this.newCompany.address
      || !this.newCompany.mail
      || !this.newCompany.town
    )
      return true;
  }

  saveCompany() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.schedules.forEach((s) => {
      if (s.closing && s.opening) {
        this.newCompany.schedules.push(s);
      }
    });
    this.companyService.createCompany(this.newCompany).subscribe({
      next: (response: ResponseObject) => {
        console.log(response);
        this.updateCompanyRoles(response.data);
        this.close.emit(this.newCompany);
        this.buttonSave.loading = false;
        this.toastService.success("Empresa creada correctamente!");
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  updateCompanyRoles(newCompanyId: any) {
    // localStorage.setItem('companyRoles', success.companyRoles);
    this.rolesAndPermissionsService.getUserRoles().subscribe({
      next: (response: ResponseObject) => {
        const newRolesUser = response.data ?? []
        const companyId = Number(newCompanyId);
        const newCompany = newRolesUser.find(
          (c: any) => c.companyId === companyId
        );

        if (!newCompany) {
          console.log("no encontro la nueva");
          return;
        }

        this.user = this.authService.getUser();
        this.user.companyRoles = [...this.user.companyRoles, newCompany];
        this.authService.setUser(this.user);
        window.location.reload();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    }
    );
  }
}
